import React from 'react';
import bemify from 'bemify-js';

import { YouTubeVideo } from '@zapier/design-system';

import Link from 'app/common/components/Link';

import './Introduction.scss';
import Paragraph from '../components/Paragraph';
import StepTitle from '../components/StepTitle';

const bem = bemify('introduction');

const Introduction = () => (
  <div className={bem()}>
    <StepTitle>Introduction</StepTitle>
    <Paragraph>
      Zapier is a service that lets non-technical folks configure sophisticated
      integrations between the apps they use, and automate the workflows they do
      every day. A Zapier App is a way for you to make your API available to the
      Zapier platform, accessible by millions of users and able to connect with
      hundreds of other applications, instantly.
    </Paragraph>
    <Paragraph>
      This tutorial assumes you have a little bit of familiarity with what a Zap
      is and the user's experience setting one up. If not, you might have a
      quick look at{' '}
      <Link href="https://help.zapier.com/hc/en-us/categories/14013973271565">
        Zapier Basics
      </Link>{' '}
      to get some of the basics that will make this exercise make a ton more
      sense.
    </Paragraph>
    <Paragraph>
      The Zapier CLI allows you to quickly create, test, deploy, and manage your
      app using tools your team is probably already familiar with. This guide
      will get you set up with everything you need and have you ready to code in
      minutes. From there our comprehensive developer guide will help you
      through every step of building a solid app for your API and creating a
      great experience for your users.
    </Paragraph>
    <div className={bem('__video')}>
      <YouTubeVideo
        title="Zapier Developer Platform CLI Introduction"
        youTubeId="CQ4j2GY-nbc"
      />
    </div>
  </div>
);

export default Introduction;
